var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgValores(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 305,
    height: 239,
    viewBox: "0 0 305 239",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M186.59 0.00326557L25.8911 59.323L127.172 239.005L287.871 179.685L186.59 0.00326557Z",
    fill: "url(#paint0_linear)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M185.289 2.08167L28.6792 59.8921L127.722 235.603L284.332 177.792L185.289 2.08167Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.421 11.9292L65.729 40.6082L74.3134 55.8377L152.006 27.1588L143.421 11.9292Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.1837 11.3846C90.1871 13.599 87.5955 19.4223 90.3973 24.3921C93.1992 29.362 100.333 31.5959 106.33 29.3815C112.326 27.1671 114.918 21.3438 112.116 16.374C109.314 11.4041 102.18 9.17016 96.1837 11.3846ZM104.183 25.5746C102.921 26.07 101.505 26.2498 100.117 26.0911C98.7279 25.9323 97.4292 25.4422 96.3864 24.6834C95.3436 23.9245 94.6039 22.9314 94.2618 21.8307C93.9197 20.7301 93.9908 19.5719 94.4659 18.5041C94.9411 17.4363 95.7987 16.5073 96.9293 15.8358C98.0599 15.1643 99.4122 14.7808 100.813 14.7341C102.215 14.6875 103.601 14.9799 104.796 15.574C105.991 16.1681 106.94 17.037 107.522 18.0696C107.912 18.74 108.135 19.466 108.178 20.2062C108.221 20.9463 108.084 21.6861 107.774 22.3833C107.464 23.0804 106.987 23.7213 106.371 24.2694C105.755 24.8175 105.011 25.2619 104.183 25.5774V25.5746Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.607 12.2426L66.5513 40.3174L74.7581 54.8771L150.813 26.8023L142.607 12.2426Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.5558 12.0481C94.4527 12.8242 92.6811 14.0875 91.4652 15.6783C90.2494 17.2692 89.6438 19.1161 89.725 20.9855C89.8062 22.8548 90.5707 24.6627 91.9216 26.1805C93.2726 27.6983 95.1494 28.8578 97.3148 29.5124C99.4801 30.1669 101.837 30.2872 104.086 29.8579C106.336 29.4286 108.378 28.469 109.954 27.1006C111.53 25.7321 112.569 24.0162 112.939 22.1699C113.31 20.3236 112.996 18.4298 112.037 16.7279C110.75 14.4462 108.397 12.6714 105.494 11.7937C102.591 10.9161 99.3756 11.0076 96.5558 12.0481ZM104.203 25.6163C102.99 26.0638 101.64 26.2102 100.325 26.037C99.0088 25.8638 97.786 25.3787 96.8108 24.6432C95.8356 23.9077 95.1518 22.9546 94.8458 21.9046C94.5398 20.8546 94.6255 19.7547 95.0919 18.7441C95.5583 17.7335 96.3845 16.8574 97.4661 16.2267C98.5476 15.5961 99.836 15.2391 101.168 15.2009C102.501 15.1627 103.817 15.445 104.951 16.0122C106.085 16.5794 106.986 17.4059 107.539 18.3874C108.281 19.7036 108.346 21.2043 107.72 22.5595C107.095 23.9146 105.83 25.0131 104.203 25.6135V25.6163Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6134 73.2557L52.082 85.6333L67.3773 112.768L100.909 100.391L85.6134 73.2557Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.038 126.987L82.5063 139.365L97.8016 166.5L131.333 154.122L116.038 126.987Z",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9434 74.7017L53.8672 86.1731L68.0425 111.321L99.1187 99.8501L84.9434 74.7017Z",
    fill: "#69F0AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.974 127.975L83.8975 139.447L98.0728 164.595L129.149 153.124L114.974 127.975Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.36 59.1947L109.764 74.9185L111.12 77.3239L153.716 61.6002L152.36 59.1947Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.133 52.5639L111.8 78.5264L113.156 80.9318L183.489 54.9694L182.133 52.5639Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.21 58.0001L113.831 82.1338L115.187 84.5393L180.566 60.4056L179.21 58.0001Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.392 112.471L139.796 128.195L141.152 130.6L183.748 114.877L182.392 112.471Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.164 105.838L141.831 131.8L143.187 134.206L213.52 108.243L212.164 105.838Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.242 111.276L143.863 135.41L145.219 137.816L210.598 113.682L209.242 111.276Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5959 94.1153L76.5983 96.2181L79.2312 83.7544L83.1256 84.6162L78.7453 100.025L66.6763 95.744L68.5959 94.1153Z",
    fill: "url(#paint5_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.6158 93.9505L76.5739 95.7772L78.8623 84.9395L82.2466 85.6897L78.4384 99.0877L67.9443 95.3673L69.6158 93.9505Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.8331 147.557L106.791 149.383L109.08 138.546L112.464 139.296L108.656 152.694L98.1616 148.973L99.8331 147.557Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.422 148.814L134.058 185.493L149.165 212.296L248.53 175.616L233.422 148.814Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.017 170.175C215.199 169.294 211.291 169.461 210.074 172.994C209.664 174.185 209.616 176.034 208.037 176.648C205.715 177.552 202.913 175.744 200.897 175.008C197.14 173.636 193.284 174.57 191.109 177.454C190.006 178.915 189.534 180.597 189.158 182.262C188.996 182.984 188.976 183.877 188.6 184.557C187.88 185.86 185.626 185.743 184.147 185.692C183.823 185.692 183.493 185.662 183.162 185.634C184.331 184.331 184.914 182.744 184.816 181.135C184.72 178.494 182.6 175.605 178.895 175.928C175.576 176.207 173.24 178.801 173.612 181.425C173.929 183.657 175.725 185.386 178.027 186.445C176.896 186.85 175.69 187.165 174.622 187.583C174.123 187.779 173.638 187.998 173.171 188.239C169.942 186.978 165.699 186.741 162.794 188.027C161.388 188.649 162.415 190.498 163.828 189.87C166.04 188.891 168.48 189.137 170.793 189.759L170.986 189.814C170.757 190.051 170.556 190.304 170.383 190.57C169.077 192.623 170.383 195.869 173.56 196.092C178.041 196.402 178.251 191.611 175.818 189.703C175.714 189.622 175.611 189.544 175.501 189.469C176.507 189.075 177.596 188.78 178.557 188.448C179.395 188.161 180.192 187.802 180.935 187.377L181.108 187.413C184.53 188.041 189.872 188.236 191.102 184.881C192.157 181.969 192.257 175.786 197.943 176.358C200.262 176.589 202.165 178.031 204.37 178.553C206.345 179.03 208.63 179.049 210.25 177.872C211.587 176.902 211.887 175.468 212.297 174.13C212.507 173.438 212.714 172.612 213.41 172.119C214.668 171.229 216.746 171.753 218.149 172.077C219.682 172.428 220.572 170.532 219.017 170.175ZM174.56 193.766C173.805 194.372 173.005 193.892 172.602 193.259C172.113 192.489 172.323 191.73 172.947 191.053C173.049 190.942 173.158 190.836 173.274 190.735C174.767 191.516 175.987 192.634 174.574 193.766H174.56ZM177.207 178.706C178.757 177.54 180.918 177.797 181.842 179.398C182.765 180.999 182.359 183.258 181.063 184.669C180.891 184.854 180.701 185.028 180.494 185.188C179.591 184.943 178.756 184.558 178.037 184.053C176.204 182.714 175.166 180.24 177.22 178.698L177.207 178.706Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.685 61.8334L211.866 70.6102C206.635 70.295 195.627 69.146 184.702 64.9765C172.54 60.3358 158.607 60.3469 146.793 65.208C119.567 65.7351 104.582 62.9127 96.5868 60.2409L98.6959 56.738L70.4981 47.8414L0 22.2725V127.069L24.6723 135.966L37.9062 110.274L66.969 121.151L72.5486 109.677L91.631 121.137L92.9302 122.021L91.1416 123.524C89.5016 124.926 88.5876 126.783 88.5876 128.713C88.5876 130.644 89.5016 132.5 91.1416 133.902C91.9352 134.581 92.8916 135.122 93.9523 135.491C95.013 135.861 96.1557 136.052 97.3105 136.052C98.4654 136.052 99.608 135.861 100.669 135.491C101.729 135.122 102.686 134.581 103.479 133.902L102.501 134.739C100.861 136.14 99.9467 137.997 99.9467 139.928C99.9467 141.858 100.861 143.715 102.501 145.116C103.294 145.795 104.251 146.336 105.311 146.706C106.372 147.075 107.515 147.266 108.67 147.266C109.824 147.266 110.967 147.075 112.028 146.706C113.089 146.336 114.045 145.795 114.839 145.116L120.491 140.361L116.61 143.624C114.97 145.026 114.056 146.883 114.056 148.813C114.056 150.743 114.97 152.6 116.61 154.002C117.404 154.681 118.36 155.222 119.421 155.591C120.481 155.961 121.624 156.151 122.779 156.151C123.934 156.151 125.076 155.961 126.137 155.591C127.198 155.222 128.154 154.681 128.948 154.002L134.527 149.308L132.18 151.283C131.034 152.262 130.395 153.559 130.395 154.908C130.395 156.257 131.034 157.555 132.18 158.534C132.735 159.008 133.403 159.385 134.143 159.643C134.884 159.901 135.682 160.035 136.488 160.035C137.295 160.035 138.093 159.901 138.833 159.643C139.574 159.385 140.242 159.008 140.796 158.534L144.518 155.405C150.911 159.184 156.084 161.942 158.617 162.656C169.173 165.618 169.173 159.686 169.173 159.686C183.272 165.615 190.323 153.756 190.323 153.756C207.948 159.686 207.948 144.86 207.948 144.86C212.352 147.331 215.53 146.198 217.749 144.023C220.772 141.072 221.141 136.909 219.066 133.567L235.911 120.97L243.197 133.024L272.26 122.147L285.494 145.889L304.983 138.847V35.1462L239.685 61.8334Z",
    fill: "url(#paint6_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.005 116.711L204.326 138.777L180.467 102.917L235.005 91.884V116.711Z",
    fill: "#BE7C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4329 58.7822C88.4329 58.7822 98.2791 69.8152 156.605 67.057L190.692 108.434L213.535 129.231C217.122 132.499 217.326 137.455 213.803 140.768C211.663 142.779 208.586 143.836 204.326 141.535C204.326 141.535 204.326 155.327 187.284 149.81C187.284 149.81 180.467 160.843 166.833 155.327C166.833 155.327 166.833 160.843 156.608 158.085C146.383 155.327 91.8413 119.469 91.8413 119.469L67.9824 105.678L88.4329 58.7822Z",
    fill: "#FDA57D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.143 72.5764C211.143 72.5764 196.413 72.5764 181.849 67.2244C168.605 62.3633 153.183 62.9825 140.962 69.3635C131.002 74.5649 122.372 83.1771 122.534 97.4006C122.534 97.4006 135.789 108.434 149.802 86.3676H160.027C160.027 86.3676 169.873 113.953 197.523 111.189C225.173 108.425 231.611 105.673 231.611 105.673L211.143 72.5764Z",
    fill: "#BE7C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.655 127.043L120.549 126.148C117.559 123.729 112.713 123.729 109.724 126.148L101.801 132.559C98.8122 134.978 98.8122 138.9 101.801 141.319L102.908 142.214C105.897 144.633 110.743 144.633 113.733 142.214L121.655 135.803C124.644 133.384 124.644 129.462 121.655 127.043Z",
    fill: "#BE7C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.669 116.623L109.563 115.727C106.574 113.308 101.727 113.308 98.738 115.727L90.8156 122.139C87.8264 124.558 87.8264 128.48 90.8156 130.899L91.9219 131.794C94.9111 134.213 99.7575 134.213 102.747 131.794L110.669 125.383C113.658 122.964 113.658 119.042 110.669 116.623Z",
    fill: "#BE7C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.991 133.937L135.885 133.041C132.896 130.622 128.049 130.622 125.06 133.041L115.434 140.831C112.445 143.25 112.445 147.172 115.434 149.591L116.541 150.486C119.53 152.905 124.376 152.905 127.366 150.486L136.991 142.697C139.981 140.278 139.981 136.356 136.991 133.937Z",
    fill: "#BE7C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.064 143.534L144.291 142.909C142.204 141.22 138.82 141.22 136.732 142.909L130.657 147.825C128.569 149.514 128.569 152.253 130.657 153.943L131.429 154.568C133.517 156.257 136.901 156.257 138.989 154.568L145.064 149.651C147.151 147.962 147.151 145.223 145.064 143.534Z",
    fill: "#BE7C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.089 122.228L238.414 133.261L207.734 72.5763L235.005 64.3015L269.089 122.228Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3066 108.436L67.9824 119.469L98.6616 58.7851L71.3908 50.5076L37.3066 108.436Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.21875 25.6833L71.3905 50.5076L27.0811 133.261L3.21875 124.986V25.6833Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.177 39.4746L235.005 64.3016L279.318 147.052L303.177 138.777V39.4746Z",
    fill: "#4D8AF0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 207.523,
    y1: 209.344,
    x2: 137.005,
    y2: 18.307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 49024.2,
    y1: -15219.5,
    x2: 48665.5,
    y2: -16191.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 14487.6,
    y1: -3023.76,
    x2: 13988.4,
    y2: -4376.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 19856.6,
    y1: 3612.47,
    x2: 18717.9,
    y2: 527.546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 23165.3,
    y1: 9397.16,
    x2: 22026.5,
    y2: 6311.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 9113.4,
    y1: 2165.28,
    x2: 8808.44,
    y2: 1339.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 182874,
    y1: 85752,
    x2: 182874,
    y2: 14253.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 305,
    height: 239,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValores);
export default __webpack_public_path__ + "static/media/valores.df51a6e0397bd9f9e26b863922734b2f.svg";
export { ForwardRef as ReactComponent };